// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"167":"422bf155","960":"c7348f12","1055":"1e5183cc","2434":"1e5183cc","4080":"807da21e","4992":"422bf155","5890":"c7348f12","7792":"c7348f12","8823":"422bf155"}[chunkId] + ".chunk.css";
};